import toast from 'react-hot-toast';

export const handleError = (error: any | unknown) => {
  if (error) {
    if (error.response?.data?.title) {
      toast.error(error.response.data.title);
    } else if (error.response?.data?.detail) {
      toast.error(error.response.data.detail[0].msg || 'An unknown error occurred.');
    } else {
      toast.error(error.message || 'An unknown error occurred.');
    }
    switch (error.response?.status) {
      case 401: {
        // Redirection vers la page de connexion
        window.location.href = '/login';
        break;
      }
      case 404: {
        toast.error('The requested resource was not found (404).');
        break;
      }
      default: {
      }
    }
  }
};
